class VicsCardGallery extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    this.images = [...this.querySelectorAll('[data-card-image]')];
    this.dots = [...this.querySelectorAll('[data-card-dot]')];
    this.current = 0;
    this.desktopInteraction = window.matchMedia('(min-width: 750px) and (hover: hover) and (pointer: fine)');
    this.desktopInteraction.addEventListener('change', () => {
      if (!this.desktopInteraction.matches) this.select(0);
    }, options);
    this.select(0);
    this.addEventListener('pointerenter', (event) => {
      if (this.desktopInteraction.matches && event.pointerType === 'mouse' && this.images.length > 1) this.select(1);
    }, options);
    this.addEventListener('pointerleave', (event) => {
      if (event.pointerType === 'mouse' && !this.contains(document.activeElement)) this.select(0);
    }, options);
    this.addEventListener('click', (event) => {
      const dot = event.target.closest('[data-card-dot]');
      if (!dot) return;
      event.preventDefault();
      event.stopPropagation();
      this.select(Number(dot.dataset.cardDot));
    }, options);
    this.addEventListener('keydown', (event) => {
      if (!event.target.closest('[data-card-dot]') || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      event.preventDefault();
      const next = (this.current + (event.key === 'ArrowRight' ? 1 : -1) + this.images.length) % this.images.length;
      this.select(next);
      this.dots[next]?.focus();
    }, options);
  }
  select(index) {
    if (!this.desktopInteraction.matches) index = 0;
    if (!this.images[index]) return;
    this.current = index;
    this.images[index].loading = 'eager';
    this.images.forEach((image, position) => { image.hidden = position !== index; });
    this.dots.forEach((dot, position) => dot.setAttribute('aria-pressed', String(position === index)));
  }
  disconnectedCallback() {
    this.controller?.abort();
    this.controller = null;
  }
}
if (!customElements.get('vics-card-gallery')) customElements.define('vics-card-gallery', VicsCardGallery);
